import React from 'react';
import { Typography } from 'components/Typography/Typography';
import * as S from './InputCharacterCounter.styles';
const InputCharacterCounter = /*#__PURE__*/React.forwardRef(({
  currentLength,
  inputState,
  maxLength
}, ref) => {
  return /*#__PURE__*/React.createElement(Typography, {
    ref: ref,
    variant: "ui",
    size: "small"
  }, /*#__PURE__*/React.createElement(S.InputCharacterCounter, {
    $state: inputState
  }, `${currentLength}/${maxLength}`));
});
export { InputCharacterCounter };